import type { GridColumnMenuItemProps, GridPinnedColumnFields } from '@mui/x-data-grid-pro';
import { GRID_TREE_DATA_GROUPING_FIELD, useGridRootProps } from '@mui/x-data-grid-pro';
import type { TableColumnDTO } from '@tempo-io/roadmap-dto';
import { ArrowBack, ArrowForward } from '@tempo-io/sui-icons';
import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import { getMoveColumnOrder } from './getMoveColumnOrder';

export type OnMoveColumn = (columns: TableColumnDTO[]) => void;

export type ColumnMenuMoveItemProps = GridColumnMenuItemProps & {
  layoutColumns: TableColumnDTO[];
  pinnedColumns: GridPinnedColumnFields;
  onMoveColumn: OnMoveColumn | undefined;
};

export const ColumnMenuMoveItem = ({
  colDef,
  onClick,
  layoutColumns,
  pinnedColumns,
  onMoveColumn,
}: ColumnMenuMoveItemProps) => {
  const rootProps = useGridRootProps();
  const { t } = useTranslation();

  if (!onMoveColumn || colDef.field === GRID_TREE_DATA_GROUPING_FIELD) return null;

  const leftResult = getMoveColumnOrder(layoutColumns, colDef.field, pinnedColumns, 'left');
  const rightResult = getMoveColumnOrder(layoutColumns, colDef.field, pinnedColumns, 'right');

  const move = (reordered: TableColumnDTO[] | undefined) => (event: React.MouseEvent) => {
    if (reordered) onMoveColumn(reordered);
    onClick(event);
  };

  const BaseMenuItem = rootProps.slots.baseMenuItem;

  return (
    <>
      <BaseMenuItem onClick={move(leftResult)} disabled={!leftResult} iconStart={<ArrowBack />}>
        {t(($) => $.views.table.columns.menu.moveLeft)}
      </BaseMenuItem>
      <BaseMenuItem
        onClick={move(rightResult)}
        disabled={!rightResult}
        iconStart={<ArrowForward />}
      >
        {t(($) => $.views.table.columns.menu.moveRight)}
      </BaseMenuItem>
    </>
  );
};
